import { useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const BASE = "https://customer-assets.emergentagent.com/job_speech-therapy-lab/artifacts";

const shots = [
  { src: `${BASE}/r216nq0e_IMG_0341.jpeg` },
  { src: `/headshots/jack-smiling-v2.jpeg` },
  { src: `/headshots/jack-adidas-v2.jpeg` },
  { src: `${BASE}/gihtr5l0_IMG_0344.jpeg` },
  { src: `${BASE}/18d0433d_IMG_0345.jpeg` },
  { src: `${BASE}/ea0jzlx4_IMG_0346.jpeg` },
];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <div>
      <Navbar />

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-36 pb-10">
        <p className="label-caps text-[#7A1C28] mb-4">Portfolio</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl font-light leading-tight max-w-3xl">
          Headshots &amp; casting gallery.
        </h1>
        <p className="text-[#4A4A4A] leading-relaxed max-w-xl mt-6">
          A selection of professional headshots and character looks, for casting directors,
          agents and collaborators. Click any image to view it larger.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24" data-testid="gallery-grid">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {shots.map((s, i) => (
            <motion.button
              key={s.src}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(s)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
              className="group relative mb-6 block w-full overflow-hidden border border-[#E5E2D9] bg-[#EFEBE1] break-inside-avoid"
            >
              <img
                src={s.src}
                alt="Jack Pritchard headshot"
                className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </motion.button>
          ))}
        </div>
      </section>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-[#1A1A1A]/90 backdrop-blur-sm flex items-center justify-center p-6"
        >
          <button
            data-testid="lightbox-close"
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-[#F7F5F0]/80 hover:text-[#F7F5F0] transition-colors"
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <motion.img
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            src={active.src}
            alt="Jack Pritchard headshot"
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] max-w-full object-contain border border-[#F7F5F0]/10"
          />
        </div>
      )}

      <Footer />
    </div>
  );
}
